import React, {useEffect, useState} from 'react'
import FormInputGroup from './FormInputGroup'
import Panel from './Panel';

function MortgageForm() {


    const getInitialState = () => {
      const value = "0";
      return value;
    };

    const getInitialDuration = () => {
      const value = "1";
      return value;
    }

    const [loanAmount, setLoanAmount] = useState('');
    const [disbursment, setDisbursement] = useState('');
    const [netIncome, setNetIncome] = useState('');
    const [value, setValue] = useState(getInitialState);
    const [duration, setDuration] = useState(getInitialDuration);
    const [upfrontFees, setUpFrontFees] = useState('');
    const [validation, setValidation] = useState(false);
    const [monthlyInstallment, setMonthlyInstallment] = useState('');
    const [netSalary, setNetSalary] = useState('');
    const [payout, setPayout] = useState('');

    const handleChange = (value) => {
      setLoanAmount(value)
      setDisbursement(Number(value) - (Number(value) * 0.1))
      console.log('Loan amount: ' + value);
      console.log('Disbursement: ' + disbursment);
    }

    const handleIncomeChange = (value) => {
      setNetIncome(value)
      console.log('Net income: ' + value);
    }


    const valueFormatter = (e) => {
      return e.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
    }
  

      const calculateAmount = (e) => {

        setMonthlyInstallment((((Number(loanAmount) * 0.1) * Number(duration)) + Number(loanAmount)) / Number(duration));

        setUpFrontFees(Number(loanAmount) * 0.1);

        let netMonthlyInstallmentTemp = (((Number(loanAmount) * 0.1) * Number(duration)) + Number(loanAmount)) / Number(duration);
        let netSalaryTemp = (netIncome) * 0.4;


        setPayout(disbursment);


        if(netMonthlyInstallmentTemp > netSalaryTemp){
          setValidation(true) //Customer has over drafted
        }else{
          setValidation(false)
        }


      }

    

  return (

    <div className = 'row shadow-sm mb-5 rounded' style={{background: '#F2F2F2', borderRadius: '5px'}}>

        <div className = 'col-sm py-4'>

        <form onSubmit={(e) => e.preventDefault()} id = 'mortgageForm'>


        <FormInputGroup 
        text='Loan Amount'  
        placeholder = {'Enter loan amount'}
        value = {loanAmount}
        onInput={(e) => handleChange(e.target.value)}
        />

        {" "}


        <FormInputGroup 
        text= {'Net Income'}
        placeholder = {'Enter net income'}
        readOnly = {false}
        value={netIncome}
        onInput={(e) => handleIncomeChange(e.target.value)}
        />
        
        {" "}


    

        <div className="input-group">
        <label style={{fontSize: '12px', color: '#17406b', marginBottom: '5px'}}>Loan Term</label>
          <select className="custom-select form-control mb-4" style={{width: '100%'}} duration={value} onChange={(e) => setDuration(e.target.value)}>
            <option value="0">Select Loan Term</option>
            <option value="1">1 Month</option>
            <option value="2">2 Months</option>
            <option value="3">3 Months</option>
            <option value="4">4 Months</option>
            <option value="5">5 Months</option>
            <option value="6">6 Months</option>
            <option value="7">7 Months</option>
            <option value="8">8 Months</option>
            <option value="9">9 Months</option>
            <option value="10">10 Months</option>
            <option value="11">11 Months</option>
            <option value="12">12 Months</option>
          </select>
        </div>



        <button className='btn btn-md w-100 center' style={{background: "#17406b", color: '#fff'}} onClick={calculateAmount}>Calculate</button>
        <button className='btn btn-md w-100 center' style={{background: "#fff", color: '#17406b', border: '1px solid #17406b', marginTop: '10px'}} onClick={() => window.location.reload(false)}>Reset</button>
  
        </form>
        </div>

        <div className = 'col-sm py-4' style={{background: '#fff'}}>
          <Panel disbursment={valueFormatter(payout)} fees={valueFormatter(upfrontFees)} percentageNetSalary={valueFormatter(netSalary)} monthlyInstallment={valueFormatter(monthlyInstallment)} validation={validation}/>
        </div>

    </div>
    
  )
}

export default MortgageForm